// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-order__selected-products {
	display: flex;
	flex-direction: column;
	gap: 8px;
	border-radius: 6px;
	position: relative;
}

.create-order__selected-products--error {
	border: 1px solid red;
}

.create-order__search {
	height: 44px;
	width: 100%;
	padding: 0 16px;
	border: 1px solid var(--gray);
	border-radius: 6px;
}

.create-order__search.products {
	padding-left: 42px;
}

.create-order__search-icon {
	position: absolute;
	top: 50%;
	left: 8px;
	transform: translateY(-50%);
}

.create-order__no-selected-label {
	color: var(--border-transparent);
	font-size: 14px;
	text-align: center;
}

.create-orders__variants-list {
	position: absolute;
	top: 52px;
	width: calc(100% + 8px);
	left: -4px;
	background-color: var(--background);
	padding: 8px;
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	z-index: 2;
	max-height: 283px;
	overflow-y: auto;
	border: 1px solid #e6e6e6;
	cursor: pointer;
}

.create-order__variant {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid #e6e6e6;
	padding: 10px;
	border-radius: 6px;
}

.create-order__variant-selected {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px;
	border-radius: 6px;
	background-color: #4db8ff;
}

.create-order__variant-selected .create-order__variant-name {
	color: #ffffff;
}

.create-order__variant-selected .create-order__variant-sku {
	color: #ffffff;
}

.create-order__variant-info-wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
}

.create-order__variant-info-wrapper img {
	width: 36px;
	height: 36px;
	border-radius: 6px;
	min-width: 36px;
}

.create-order__variant-info {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.create-order__variant-name {
	font-size: 16px;
	line-height: 16px;
	font-weight: 500;
	color: #191919;
}

.create-order__variant-sku {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
}

.create-order__variant-empty-image {
	width: 36px;
	height: 36px;
	border-radius: 6px;
	background-color: var(--gray);
	min-width: 36px;
}

.create-order__add-button {
	background-color: transparent;
	color: var(--background);
	border: none;
	border-radius: 6px;
	font-size: 16px;
	cursor: pointer;
	height: 30px;
	width: 30px;
}

.create-order__selected-variants-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
	position: relative;
}

.create-order__input-wrapper {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.create-order__required {
	color: red;
	margin-left: 5px;
}

.create-order__create-button {
	background-color: var(--button);
	color: var(--background);
	border: none;
	border-radius: 6px;
	padding: 8px 16px;
	font-size: 16px;
	cursor: pointer;
	transition: 0.3s;
	margin-top: 10px;
}

.create-order__create-button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.create-order__selected-variant-options {
	display: flex;
	align-items: center;
	gap: 4px;
}

.create-order__quantity-input-wrapper {
	display: flex;
	align-items: center;
	border-radius: 3px;
	overflow: hidden;
	background-color: #ffffff;
}

.create-order__quantity-input {
	min-width: 25px;
	width: 25px;
	max-width: 40px;
	height: 34px;
	text-align: center;
}

.create-order__quantity-input-decrease {
	height: 34px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.3s;
	padding: 0 6px;
}

.create-order__quantity-input-increase {
	height: 34px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.3s;
	padding: 0 6px;
}

.create-order__quantity-input-increase:hover,
.create-order__quantity-input-decrease:hover {
	background-color: var(--gray);
	transition: 0.3s;
}

.create-order__search--error {
	border: 1px solid red !important;
}

.fulfillment-select-modal__description {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
}

.fulfillment-select-modal__body {
	padding-top: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.fulfillment-select-modal__integration-block {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	height: 77px;
	border-bottom: 1px solid #e6e6e6;
}

.fulfillment-select-modal__integration-name {
	font-size: 20px;
	line-height: 27px;
	font-weight: 500;
	color: #191919;
}

.create-order__search-wrapper {
	position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/app/modals/CreateOrder/CreateOrder.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,uBAAuB;CACvB,UAAU;CACV,mCAAmC;CACnC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,UAAU;CACV,iBAAiB;CACjB,gBAAgB;CAChB,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,yBAAyB;CACzB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,aAAa;CACb,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,wBAAwB;CACxB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,wBAAwB;CACxB,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;;CAEC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".create-order__selected-products {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tborder-radius: 6px;\n\tposition: relative;\n}\n\n.create-order__selected-products--error {\n\tborder: 1px solid red;\n}\n\n.create-order__search {\n\theight: 44px;\n\twidth: 100%;\n\tpadding: 0 16px;\n\tborder: 1px solid var(--gray);\n\tborder-radius: 6px;\n}\n\n.create-order__search.products {\n\tpadding-left: 42px;\n}\n\n.create-order__search-icon {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 8px;\n\ttransform: translateY(-50%);\n}\n\n.create-order__no-selected-label {\n\tcolor: var(--border-transparent);\n\tfont-size: 14px;\n\ttext-align: center;\n}\n\n.create-orders__variants-list {\n\tposition: absolute;\n\ttop: 52px;\n\twidth: calc(100% + 8px);\n\tleft: -4px;\n\tbackground-color: var(--background);\n\tpadding: 8px;\n\tborder-radius: 6px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tz-index: 2;\n\tmax-height: 283px;\n\toverflow-y: auto;\n\tborder: 1px solid #e6e6e6;\n\tcursor: pointer;\n}\n\n.create-order__variant {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder: 1px solid #e6e6e6;\n\tpadding: 10px;\n\tborder-radius: 6px;\n}\n\n.create-order__variant-selected {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tbackground-color: #4db8ff;\n}\n\n.create-order__variant-selected .create-order__variant-name {\n\tcolor: #ffffff;\n}\n\n.create-order__variant-selected .create-order__variant-sku {\n\tcolor: #ffffff;\n}\n\n.create-order__variant-info-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.create-order__variant-info-wrapper img {\n\twidth: 36px;\n\theight: 36px;\n\tborder-radius: 6px;\n\tmin-width: 36px;\n}\n\n.create-order__variant-info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.create-order__variant-name {\n\tfont-size: 16px;\n\tline-height: 16px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.create-order__variant-sku {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n}\n\n.create-order__variant-empty-image {\n\twidth: 36px;\n\theight: 36px;\n\tborder-radius: 6px;\n\tbackground-color: var(--gray);\n\tmin-width: 36px;\n}\n\n.create-order__add-button {\n\tbackground-color: transparent;\n\tcolor: var(--background);\n\tborder: none;\n\tborder-radius: 6px;\n\tfont-size: 16px;\n\tcursor: pointer;\n\theight: 30px;\n\twidth: 30px;\n}\n\n.create-order__selected-variants-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tposition: relative;\n}\n\n.create-order__input-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2px;\n}\n\n.create-order__required {\n\tcolor: red;\n\tmargin-left: 5px;\n}\n\n.create-order__create-button {\n\tbackground-color: var(--button);\n\tcolor: var(--background);\n\tborder: none;\n\tborder-radius: 6px;\n\tpadding: 8px 16px;\n\tfont-size: 16px;\n\tcursor: pointer;\n\ttransition: 0.3s;\n\tmargin-top: 10px;\n}\n\n.create-order__create-button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.create-order__selected-variant-options {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.create-order__quantity-input-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: 3px;\n\toverflow: hidden;\n\tbackground-color: #ffffff;\n}\n\n.create-order__quantity-input {\n\tmin-width: 25px;\n\twidth: 25px;\n\tmax-width: 40px;\n\theight: 34px;\n\ttext-align: center;\n}\n\n.create-order__quantity-input-decrease {\n\theight: 34px;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: 0.3s;\n\tpadding: 0 6px;\n}\n\n.create-order__quantity-input-increase {\n\theight: 34px;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: 0.3s;\n\tpadding: 0 6px;\n}\n\n.create-order__quantity-input-increase:hover,\n.create-order__quantity-input-decrease:hover {\n\tbackground-color: var(--gray);\n\ttransition: 0.3s;\n}\n\n.create-order__search--error {\n\tborder: 1px solid red !important;\n}\n\n.fulfillment-select-modal__description {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n}\n\n.fulfillment-select-modal__body {\n\tpadding-top: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.fulfillment-select-modal__integration-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n\theight: 77px;\n\tborder-bottom: 1px solid #e6e6e6;\n}\n\n.fulfillment-select-modal__integration-name {\n\tfont-size: 20px;\n\tline-height: 27px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.create-order__search-wrapper {\n\tposition: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
